module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "warp clearfix"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mp4Show),
      expression: "mp4Show"
    }],
    staticClass: "mp4-area",
    attrs: {
      "id": "mp4"
    }
  }, [_c('div', {
    attrs: {
      "id": "coor"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mp4-head"
  }, [_c('span', [_vm._v(_vm._s(_vm.lessonName))]), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-yichu",
    attrs: {
      "id": "close-mp4"
    },
    on: {
      "click": _vm.closeMp4
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mp4-left"
  }, [_c('ul', _vm._l((_vm.lessonInfo.videoList), function(video, index) {
    return _c('li', {
      key: index,
      class: {
        'play-now': _vm.playIndex == index
      },
      on: {
        "click": function($event) {
          return _vm.playVideo(video, index)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(video.fileName))]), _vm._v(" "), _c('span')])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "mp4-video"
  }, [(_vm.videoShow) ? _c('video', {
    ref: "video",
    attrs: {
      "id": "videoElement",
      "controls": "",
      "autoplay": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.videoSrc,
      "type": "video/ogg"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": _vm.videoSrc,
      "type": "video/mp4"
    }
  }), _vm._v(" "), _vm._m(0)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "left-area",
    attrs: {
      "id": "drag-left"
    }
  }, [_c('div', {
    attrs: {
      "id": "drag"
    },
    on: {
      "mousedown": _vm.drag,
      "mouseup": _vm.dragup
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top-area"
  }, [_c('div', {
    staticClass: "tab-area left-tabs left-tabs-js"
  }, [_c('span', {
    staticClass: "tab-checked",
    attrs: {
      "title": "file-area"
    },
    on: {
      "click": function($event) {
        return _vm.leftTabChange($event, 'file-area')
      }
    }
  }, [_vm._v("附件(" + _vm._s(_vm.attachList.length) + ")")]), _vm._v(" "), _c('span', {
    attrs: {
      "title": "image-area"
    },
    on: {
      "click": function($event) {
        return _vm.leftTabChange($event, 'image-area')
      }
    }
  }, [_vm._v("影像(" + _vm._s(_vm.studyList.length) + ")")]), _vm._v(" "), _c('span', {
    attrs: {
      "title": "mr-area"
    },
    on: {
      "click": function($event) {
        return _vm.leftTabChange($event, 'mr-area')
      }
    }
  }, [_vm._v("病例资料(" + _vm._s(_vm.caseList.length) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "list-area image-area",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "list-head",
    class: {
      paddingRight17: _vm.isPaddingRight
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]), _vm._v(" "), (_vm.imageList.length == 0) ? _c('p', {
    staticStyle: {
      "margin-top": "calc((50vh - 128px))",
      "text-align": "center"
    }
  }, [_vm._v("暂无数据")]) : _c('ul', {
    staticClass: "list-body"
  }, _vm._l((_vm.imageList), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        checked: index == _vm.imageListI
      },
      on: {
        "click": function($event) {
          return _vm._getReportInfo(item, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('b', [_vm._v(_vm._s(item.accessionNumber))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('b', [_vm._v(_vm._s(item.patientSex))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('b', [_vm._v(_vm._s(item.patientAge))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('b', [_vm._v(_vm._s(item.examTypeName))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "20%",
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "white-space": "nowrap"
      },
      attrs: {
        "title": item.examBodyName
      }
    }, [_c('b', [_vm._v(_vm._s(item.examBodyName))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "list-area mr-area",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "list-head",
    class: {
      paddingRight17: _vm.isPaddingRight
    }
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)]), _vm._v(" "), (_vm.dataList.length == 0) ? _c('p', {
    staticStyle: {
      "margin-top": "calc((50vh - 128px))",
      "text-align": "center"
    }
  }, [_vm._v("暂无数据")]) : _c('ul', {
    staticClass: "list-body"
  }, _vm._l((_vm.dataList), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        checked: index == _vm.mrListI
      },
      on: {
        "click": function($event) {
          return _vm._getMrInfo(item, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "width": "40%",
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "white-space": "nowrap"
      },
      attrs: {
        "title": item.caseName
      }
    }, [_c('b', [_vm._v(_vm._s(item.caseName))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('b', [_vm._v(_vm._s(item.privateType))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('b', [_vm._v(_vm._s(item.caseSex))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "20%"
      }
    }, [_c('b', [_vm._v(_vm._s(item.caseAge))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "list-area file-area",
    staticStyle: {
      "display": "block"
    }
  }, [_vm._m(10), _vm._v(" "), (_vm.fileTypeList.length == 0) ? _c('p', {
    staticStyle: {
      "position": "relative",
      "top": "calc((200px - 64px))",
      "text-align": "center",
      "min-height": "200px"
    }
  }, [_vm._v("暂无数据")]) : _c('div', {
    staticClass: "left-file-content"
  }, _vm._l((_vm.fileTypeList), function(item, index) {
    return _c('p', {
      key: index,
      class: {
        'file-checked': index == _vm.rightFileIndex
      },
      on: {
        "click": function($event) {
          return _vm.showFile('file', item, index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.attach_name))])])
  }), 0), _vm._v(" "), _vm._m(11), _vm._v(" "), (_vm.filePicList.length == 0) ? _c('p', {
    staticStyle: {
      "position": "relative",
      "top": "calc((200px - 64px))",
      "text-align": "center",
      "min-height": "200px"
    }
  }, [_vm._v("暂无数据")]) : _c('div', {
    staticClass: "left-file-content"
  }, _vm._l((_vm.filePicList), function(item, index) {
    return _c('p', {
      key: index,
      class: {
        'file-checked': index == _vm.rightPicIndex
      },
      on: {
        "click": function($event) {
          return _vm.showFile('img', item, index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.attach_name))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "right-area",
    attrs: {
      "id": "drag-right"
    }
  }, [_c('div', {
    staticClass: "top-area"
  }, [_c('b', {
    staticStyle: {
      "color": "#000",
      "font-weight": "blod",
      "font-size": "18px"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.lessonInfo.subject))])])]), _vm._v(" "), _c('div', {
    staticClass: "right-area-inner"
  }, [_c('div', {
    staticClass: "right-area-js image-area list-area",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "report-area"
  }, [_c('h3', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold",
      "color": "#000"
    }
  }, [_vm._v(_vm._s(_vm.examTypeNameres) + "报告单")]), _vm._v(" "), _c('span', {
    staticClass: "rep-button-area"
  }, [_c('a', {
    staticClass: "button btn2",
    staticStyle: {
      "background": "#898989"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.getReport
    }
  }, [_vm._v("查看申请单")]), _vm._v(" "), _c('a', {
    staticClass: "button btn1",
    staticStyle: {
      "background": "#898989"
    },
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("电子病历")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.readFilmY),
      expression: "readFilmY"
    }],
    staticClass: "button btn3",
    staticStyle: {
      "padding": "7px 30px"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.getImage()
      }
    }
  }, [_vm._v("阅片")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.readFilmN),
      expression: "readFilmN"
    }],
    staticClass: "button btn4",
    staticStyle: {
      "background": "#898989",
      "padding": "7px 30px"
    },
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("阅片")])])]), _vm._v(" "), _c('div', {}, [_c('report', {
    attrs: {
      "info": _vm.reportInfo
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "right-area-js mr-area list-area",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "mr-deital-area"
  }, [_c('div', {
    staticClass: "mr-tabs clearfix"
  }, [_c('span', {
    staticClass: "mr-tab-checked",
    attrs: {
      "title": "mr-info"
    },
    on: {
      "click": function($event) {
        return _vm.rightTabChange($event, 'mr-info')
      }
    }
  }, [_vm._v("病例信息")]), _vm._v(" "), _c('span', {
    attrs: {
      "title": "mr-img"
    },
    on: {
      "click": function($event) {
        return _vm.rightTabChange($event, 'mr-img')
      }
    }
  }, [_vm._v("关联影像")]), _vm._v(" "), _c('span', {
    attrs: {
      "title": "mr-file"
    },
    on: {
      "click": function($event) {
        return _vm.rightTabChange($event, 'mr-file')
      }
    }
  }, [_vm._v("病例附件")])]), _vm._v(" "), _c('div', {
    staticClass: "mr-info-content",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "mr-info"
    }
  }, [_c('h5', [_vm._v("| 基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix mr-info-row"
  }, [_c('span', {
    staticClass: "mr-info-title"
  }, [_vm._v("病例名称：")]), _vm._v(" "), _c('p', {
    staticClass: "mr-info-detail-1"
  }, [_vm._v(_vm._s(_vm.mrInfo.caseName))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix mr-info-row"
  }, [_c('span', {
    staticClass: "mr-info-title"
  }, [_vm._v("性别：")]), _vm._v(" "), _c('p', {
    staticClass: "mr-info-detail"
  }, [_vm._v(_vm._s(_vm.mrInfo.caseSex))]), _vm._v(" "), _c('span', {
    staticClass: "mr-info-title"
  }, [_vm._v("年龄：")]), _vm._v(" "), _c('p', {
    staticClass: "mr-info-detail"
  }, [(_vm.mrInfo.caseAge != undefined && _vm.mrInfo.caseAge.indexOf('undefined') < 0) ? _c('span', [_vm._v(_vm._s(_vm.mrInfo.caseAge))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix mr-info-row"
  }, [_c('span', {
    staticClass: "mr-info-title"
  }, [_vm._v("创建时间：")]), _vm._v(" "), _c('p', {
    staticClass: "mr-info-detail"
  }, [_vm._v(_vm._s(_vm.mrInfo.createDate))]), _vm._v(" "), _c('span', {
    staticClass: "mr-info-title"
  }, [_vm._v("创建人：")]), _vm._v(" "), _c('p', {
    staticClass: "mr-info-detail"
  }, [_vm._v(_vm._s(_vm.mrInfo.creatorName))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix mr-info-row"
  }, [_c('span', {
    staticClass: "mr-info-title"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('p', {
    staticClass: "mr-info-detail-1"
  }, [_vm._v(_vm._s(_vm.mrInfo.remark))])]), _vm._v(" "), _c('h5', [_vm._v("| 就诊信息")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix mr-info-row"
  }, [_c('span', {
    staticClass: "mr-info-title"
  }, [_vm._v("病史：")]), _vm._v(" "), _c('p', {
    staticClass: "mr-info-detail-1"
  }, [_vm._v(_vm._s(_vm.mrInfo.history))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix mr-info-row"
  }, [_c('span', {
    staticClass: "mr-info-title"
  }, [_vm._v("病理结果：")]), _vm._v(" "), _c('p', {
    staticClass: "mr-info-detail-1"
  }, [_vm._v(_vm._s(_vm.mrInfo.caseResult))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix mr-info-row"
  }, [_c('span', {
    staticClass: "mr-info-title"
  }, [_vm._v("影像所见：")]), _vm._v(" "), _c('p', {
    staticClass: "mr-info-detail-1"
  }, [_vm._v(_vm._s(_vm.mrInfo.evidence))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix mr-info-row"
  }, [_c('span', {
    staticClass: "mr-info-title"
  }, [_vm._v("诊断结果：")]), _vm._v(" "), _c('p', {
    staticClass: "mr-info-detail-1"
  }, [_vm._v(_vm._s(_vm.mrInfo.dianogeResult))])])]), _vm._v(" "), _c('div', {
    staticClass: "mr-info-content",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "mr-img"
    }
  }, [_vm._m(12), _vm._v(" "), (_vm.isNoStudyList) ? _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(13)]) : _c('div', {
    staticClass: "mr-info-img-list-body"
  }, _vm._l((_vm.mrInfo.studyList), function(item, index) {
    return _c('p', {
      key: index,
      class: {
        'background-dark': index % 2 == 1
      }
    }, [_c('span', {
      staticStyle: {
        "width": "15%"
      },
      attrs: {
        "title": item.hospitalName
      }
    }, [_vm._v(_vm._s(item.hospitalName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "15%"
      },
      attrs: {
        "title": item.examTypeName
      }
    }, [_vm._v(_vm._s(item.examTypeName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "20%"
      },
      attrs: {
        "title": item.creatorName
      }
    }, [_vm._v(_vm._s(item.patientName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "title": item.patientSex
      }
    }, [_vm._v(_vm._s(item.patientSex))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "title": item.patientAge
      }
    }, [_vm._v(_vm._s(item.patientAge))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "20%"
      },
      attrs: {
        "title": item.examBodyName
      }
    }, [_vm._v(_vm._s(item.examBodyName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('i', {
      staticClass: "iconfont icon-yuepian",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "阅片"
      },
      on: {
        "click": function($event) {
          return _vm.getImage(item)
        }
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "mr-info-content",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "mr-file"
    }
  }, [_c('div', {
    staticClass: "mr-info-file-area clearfix"
  }, [_c('span', [_vm._v("课件类型：")]), _vm._v(" "), _c('div', {
    staticClass: "file-content clearfix"
  }, _vm._l((_vm.caseTypeList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item-file"
    }, [_c('a', {
      attrs: {
        "href": _vm.caseFileurl
      }
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.attach_name))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "mr-info-file-area"
  }, [_c('span', [_vm._v("其他图片：")]), _vm._v(" "), _c('div', {
    staticClass: "file-content clearfix"
  }, _vm._l((_vm.casePicList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item-file"
    }, [_c('img', {
      attrs: {
        "src": item.fileurl,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.showBigImg(item.fileurl)
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.attach_name))])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-area-js file-area list-area",
    staticStyle: {
      "display": "block",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "mr-file-area"
  }, [(_vm.rightFileShow && !_vm.rightDownLoadUrl) ? _c('p', [_vm._m(14)]) : _vm._e(), _vm._v(" "), (_vm.rightFileShow && _vm.rightDownLoadUrl) ? _c('div', {
    staticStyle: {
      "width": "90%",
      "height": "90%"
    }
  }, [_c('p', {
    staticStyle: {
      "width": "400px",
      "text-align": "center",
      "margin": "20% auto"
    }
  }, [_vm._v("\n                暂不支持预览，请下载附件\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "href": _vm.rightDownLoadUrl
    }
  }, [_vm._v("下载附件")])])]) : _vm._e(), _vm._v(" "), (!_vm.rightFileShow) ? _c('img', {
    staticClass: "mr-pic",
    attrs: {
      "src": _vm.rightImgSrc,
      "alt": ""
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "tools-area"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.OpenTool),
      expression: "OpenTool"
    }],
    staticClass: "open-tools-area",
    attrs: {
      "id": "open-tool"
    },
    on: {
      "click": _vm.openTools
    }
  }, [_vm._v("显示工具栏")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.CloseTool),
      expression: "CloseTool"
    }],
    staticClass: "open-tools-area",
    attrs: {
      "id": "open-tool"
    },
    on: {
      "click": _vm.openTools
    }
  }, [_vm._v("收起工具栏")]), _vm._v(" "), _c('h2', [(_vm.oLessonObj.type != 'tenchManage' && _vm.lessonInfo.teachType != 2) ? _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.timeStr))]) : _vm._e(), _vm._v(" "), (_vm.oLessonObj.type != 'tenchManage' && _vm.lessonInfo.teachType == 2) ? _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.timeStr))]) : _vm._e(), _vm._v(" "), (_vm.oLessonObj.type == 'tenchManage' && _vm.lessonInfo.teachType == 1) ? _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.timeStr))]) : _vm._e(), _vm._v(" "), (_vm.oLessonObj.type != 'tenchManage' && _vm.lessonInfo.teachType != 2) ? _c('p', {
    staticClass: "time-text"
  }, [_vm._v("已学习时间")]) : _vm._e(), _vm._v(" "), (_vm.oLessonObj.type != 'tenchManage' && _vm.lessonInfo.teachType == 2) ? _c('p', {
    staticClass: "time-text"
  }, [_vm._v("已学习时间")]) : _vm._e(), _vm._v(" "), (_vm.oLessonObj.type != '1' && _vm.lessonInfo.teachType != '2') ? _c('p', {
    staticClass: "time-text"
  }, [_vm._v("已上课时间")]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.lessonInfo.courseState == 4 && _vm.lessonInfo.teachType == '1' && _vm.oLessonObj.type == '1' && _vm.lessonInfo.videoList.length == 0) ? _c('a', {
    staticClass: "button button-size-big hover-btn",
    staticStyle: {
      "background": "#898989"
    },
    attrs: {
      "href": "javascript:void(0);",
      "id": "open-vedio"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-kaiqi",
    staticStyle: {
      "font-size": "12px !important",
      "margin-right": "6px"
    }
  }), _vm._v(" 观看视频\n            ")]) : _vm._e(), _vm._v(" "), (_vm.lessonInfo.teachType == '1' && _vm.oLessonObj.type == '1' && _vm.lessonInfo.videoList.length > 0) ? _c('a', {
    staticClass: "button button-size-big hover-btn",
    attrs: {
      "href": "javascript:void(0);",
      "id": "open-vedio"
    },
    on: {
      "click": _vm.openMp4
    }
  }, [_c('i', {
    staticClass: "iconfont icon-kaiqi",
    staticStyle: {
      "font-size": "12px !important",
      "margin-right": "6px"
    }
  }), _vm._v(" 观看视频\n            ")]) : _vm._e(), _vm._v(" "), (_vm.lessonInfo.courseState != 4 && _vm.lessonInfo.teachType == '1' && _vm.oLessonObj.type == '1' && _vm.lessonInfo.videoList.length == 0) ? _c('a', {
    staticClass: "button button-size-big hover-btn",
    attrs: {
      "href": "javascript:void(0);",
      "id": "open-vedio"
    },
    on: {
      "click": _vm.openMp4
    }
  }, [_c('i', {
    staticClass: "iconfont icon-kaiqi",
    staticStyle: {
      "font-size": "12px !important",
      "margin-right": "6px"
    }
  }), _vm._v(" 观看视频\n            ")]) : _vm._e(), _vm._v(" "), (_vm.lessonInfo.courseState != 4 && _vm.lessonInfo.teachType != '1' && _vm.oLessonObj.type == '1') ? _c('a', {
    staticClass: "button button-size-big hover-btn",
    staticStyle: {
      "background": "#898989"
    },
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-kaiqi",
    staticStyle: {
      "font-size": "12px !important",
      "margin-right": "6px"
    }
  }), _vm._v(" 观看视频\n            ")]) : _vm._e(), _vm._v(" "), (_vm.oLessonObj.type != '1' && _vm.lessonInfo.teachType == '1' && _vm.lessonInfo.courseState == '4' && _vm.lessonInfo.videoList.length == '0') ? _c('a', {
    staticClass: "button button-size-big",
    staticStyle: {
      "background": "#898989"
    },
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-kaiqi",
    staticStyle: {
      "font-size": "12px !important",
      "margin-right": "6px"
    }
  }), _vm._v(" 观看视频\n            ")]) : _vm._e(), _vm._v(" "), (_vm.oLessonObj.type != '1' && _vm.lessonInfo.teachType != '1') ? _c('a', {
    staticClass: "button button-size-big",
    staticStyle: {
      "background": "#898989"
    },
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-kaiqi",
    staticStyle: {
      "font-size": "12px !important",
      "margin-right": "6px"
    }
  }), _vm._v(" 开启视频\n            ")]) : _vm._e(), _vm._v(" "), (_vm.oLessonObj.type != '1' && _vm.lessonInfo.teachType == '1' && _vm.lessonInfo.courseState == '4' && _vm.lessonInfo.videoList.length > 0) ? _c('a', {
    staticClass: "button button-size-big",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.openMp4
    }
  }, [_c('i', {
    staticClass: "iconfont icon-kaiqi",
    staticStyle: {
      "font-size": "12px !important",
      "margin-right": "6px"
    }
  }), _vm._v(" 观看视频\n            ")]) : _vm._e(), _vm._v(" "), (_vm.oLessonObj.type != '1' && _vm.lessonInfo.teachType == '1' && _vm.lessonInfo.courseState != '4') ? _c('a', {
    staticClass: "button button-size-big",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.openMp4
    }
  }, [_c('i', {
    staticClass: "iconfont icon-kaiqi",
    staticStyle: {
      "font-size": "12px !important",
      "margin-right": "6px"
    }
  }), _vm._v(" 开启视频\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "lesson-area"
  }, [_c('p', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "lesson-title"
  }, [_vm._v("授课人：")]), _vm._v(" "), _c('span', {
    staticClass: "lesson-content"
  }, [_vm._v(_vm._s(_vm.lessonInfo.teacherName))])]), _vm._v(" "), _c('p', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "lesson-title"
  }, [_vm._v("课程时间：")]), _vm._v(" "), _c('span', {
    staticClass: "lesson-content"
  }, [_vm._v(_vm._s(_vm.lessonInfo.courseTime))])]), _vm._v(" "), _c('p', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "lesson-title"
  }, [_vm._v("课程分类：")]), _vm._v(" "), _c('span', {
    staticClass: "lesson-content"
  }, [_vm._v(_vm._s(_vm.lessonInfo.courseType))])]), _vm._v(" "), _c('p', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "lesson-title"
  }, [_vm._v("学科分类：")]), _vm._v(" "), _c('span', {
    staticClass: "lesson-content"
  }, [_vm._v(_vm._s(_vm.lessonInfo.scienceType || '所有'))])]), _vm._v(" "), _c('p', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "lesson-title"
  }, [_vm._v("课程简介：")]), _vm._v(" "), _c('span', {
    staticClass: "lesson-content",
    class: {
      'p-line2': _vm.line2
    },
    staticStyle: {
      "overflow": "hidden",
      "width": "140px",
      "text-overflow": "ellipsis",
      "display": "-webkit-box",
      "-webkit-box-orient": "vertical",
      "-webkit-line-clamp": "2"
    },
    attrs: {
      "title": _vm.lessonInfo.remark
    }
  }, [_vm._v(_vm._s(_vm.lessonInfo.remark))])]), _vm._v(" "), _c('p', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "lesson-title"
  }, [_vm._v("最近学员：")]), _vm._v(" "), _c('span', {
    staticClass: "lesson-content",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.nowStuList.length))]), _vm._v(" "), _c('b', [_vm._v("人")]), _vm._v(" "), _vm._l((_vm.nowStuList), function(stu, index) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index < 5),
        expression: "index < 5"
      }],
      key: index,
      staticClass: "stu-avatar",
      attrs: {
        "title": stu.doctorNeme
      }
    }, [(stu.img == undefined || '') ? _c('img', {
      staticClass: "stu-avatar",
      attrs: {
        "src": require("../../../../static/image/user.png")
      }
    }) : _c('img', {
      staticClass: "stu-avatar",
      attrs: {
        "src": stu.img,
        "onerror": _vm.errorImg
      }
    })])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "stu-avatar-arrow"
  }, [_vm._v("＞")])]), _vm._v(" "), (_vm.oLessonObj.type != '1') ? _c('div', {
    staticClass: "good-area clearfix",
    staticStyle: {
      "background": "rgba(0, 0, 0, 0.3)",
      "padding": "10px",
      "border-radius": "4px"
    }
  }, [_c('span', {
    staticClass: "good-button"
  }, [_c('i', {
    staticClass: "iconfont icon-dianzan"
  }), _vm._v(" 点赞\n              "), _c('span', [_vm._v(_vm._s(_vm.lessonInfo.goodNum))])]), _vm._v(" "), _c('span', {
    staticClass: "collect-button"
  }, [(_vm.collectOperateType == '1') ? _c('i', {
    staticClass: "iconfont icon-shoucang"
  }) : _c('i', {
    staticClass: "iconfont icon-yishoucang"
  }), _vm._v("\n              收藏\n              "), _c('span', [_vm._v(_vm._s(_vm.lessonInfo.collectNum))])])]) : _c('div', {
    staticClass: "good-area clearfix"
  }, [_c('a', {
    staticClass: "good-button",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.goodLesson
    }
  }, [(_vm.goodOperateType == '1') ? _c('i', {
    staticClass: "iconfont icon-dianzan"
  }) : _c('i', {
    staticClass: "iconfont icon-yidianzan"
  }), _vm._v("\n              点赞\n              "), _c('span', [_vm._v(_vm._s(_vm.lessonInfo.goodNum))]), _vm._v(" "), (_vm.isAdd) ? _c('span', {
    staticClass: "addgood"
  }, [_vm._v("+1")]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "collect-button",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.collectLesson
    }
  }, [(_vm.collectOperateType == '1') ? _c('i', {
    staticClass: "iconfont icon-shoucang"
  }) : _c('i', {
    staticClass: "iconfont icon-yishoucang"
  }), _vm._v("\n              收藏\n              "), _c('span', [_vm._v(_vm._s(_vm.lessonInfo.collectNum))]), _vm._v(" "), (_vm.isAdd1) ? _c('span', {
    staticClass: "addgood"
  }, [_vm._v("+1")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "ending-study-area"
  }, [(_vm.oLessonObj.type == '1' && this.isEnd) ? _c('a', {
    staticClass: "button button-size-big",
    staticStyle: {
      "background": "#898989"
    },
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jieshu",
    staticStyle: {
      "font-size": "12px !important",
      "margin-right": "6px"
    }
  }), _vm._v("结束学习\n            ")]) : _vm._e(), _vm._v(" "), (_vm.oLessonObj.type == '1' && !this.isEnd) ? _c('a', {
    staticClass: "button button-size-big",
    attrs: {
      "id": "end-study",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.endStu('你已完成当前课程了吗？')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jieshu",
    staticStyle: {
      "font-size": "12px !important",
      "margin-right": "6px"
    }
  }), _vm._v("结束学习\n            ")]) : _vm._e(), _vm._v(" "), (_vm.oLessonObj.type == 'tenchManage' && _vm.lessonInfo.teachType == '2' && _vm.lessonInfo.courseState == 4) ? _c('a', {
    staticClass: "button button-size-big",
    attrs: {
      "id": "end-study",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.endStu('您确定要离开当前课程吗？')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jieshu",
    staticStyle: {
      "font-size": "12px !important",
      "margin-right": "6px"
    }
  }), _vm._v("离开课程\n            ")]) : _vm._e(), _vm._v(" "), (_vm.oLessonObj.type != '1' && _vm.lessonInfo.teachType == '1' && _vm.lessonInfo.courseState == '4') ? _c('a', {
    staticClass: "button button-size-big",
    attrs: {
      "id": "end-study",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.endStu('您确定要离开当前课程吗？')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jieshu",
    staticStyle: {
      "font-size": "12px !important",
      "margin-right": "6px"
    }
  }), _vm._v("离开课程\n            ")]) : _vm._e(), _vm._v(" "), (_vm.oLessonObj.type != '1' && _vm.lessonInfo.teachType == '1' && _vm.lessonInfo.courseState != '4') ? _c('a', {
    staticClass: "button button-size-big",
    attrs: {
      "id": "end-study",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.endStu('您确定要结束当前课程吗？')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jieshu",
    staticStyle: {
      "font-size": "12px !important",
      "margin-right": "6px"
    }
  }), _vm._v("结束课程\n            ")]) : _vm._e(), _vm._v(" "), (_vm.oLessonObj.type != '1' && _vm.lessonInfo.teachType != '1') ? _c('a', {
    staticClass: "button button-size-big",
    attrs: {
      "id": "end-study",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.endStu('您确定要离开当前课程吗？')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jieshu",
    staticStyle: {
      "font-size": "12px !important",
      "margin-right": "6px"
    }
  }), _vm._v("离开课程\n            ")]) : _vm._e()])])])])]), _vm._v(" "), (_vm.repShow) ? _c('pops', {
    staticClass: "collect",
    attrs: {
      "show": _vm.repShow,
      "width": _vm.popwidth,
      "title": _vm.title,
      "classes": 'Collections'
    },
    on: {
      "closePop": _vm.closePop
    }
  }, [_c('elcRep', {
    attrs: {
      "elcRep": _vm.elcRep,
      "emergent": _vm.emergent
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.filePop) ? _c('pops', {
    class: 'mrDialog',
    attrs: {
      "show": _vm.filePop,
      "title": '',
      "width": '980px'
    },
    on: {
      "closePop": _vm.closeFile
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.url,
      "width": "100%",
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('pops', {
    attrs: {
      "show": _vm.fileShow,
      "title": '',
      "width": '980px'
    },
    on: {
      "closePop": _vm.closeBigFile
    }
  }, [_c('iframe', {
    attrs: {
      "src": _vm.Url,
      "frameborder": "0",
      "width": "100%",
      "height": "500px"
    }
  })]), _vm._v(" "), _c('aycanImages', {
    ref: "aycanImages",
    attrs: {
      "hospitalId": _vm.params_image.hospitalId,
      "studyPk": _vm.params_image.studyPk,
      "studyUid": _vm.params_image.studyUid
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('object', {
    attrs: {
      "data": "movie.mp4",
      "width": "320",
      "height": "240"
    }
  }, [_c('embed', {
    attrs: {
      "width": "320",
      "height": "240",
      "src": "movie.swf"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_c('b', [_vm._v("检查编号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_c('b', [_vm._v("性别")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_c('b', [_vm._v("年龄")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_c('b', [_vm._v("类型")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_c('b', [_vm._v("检查项目")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "width": "40%"
    }
  }, [_c('b', [_vm._v("病例名称")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_c('b', [_vm._v("权限")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_c('b', [_vm._v("性别")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_c('b', [_vm._v("年龄")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-title"
  }, [_c('b', [_vm._v("1")]), _vm._v(" 课件类型\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-title"
  }, [_c('b', [_vm._v("2")]), _vm._v(" 其他图片\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mr-info-img-list-head"
  }, [_c('span', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("来源")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("检查类型")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("性别")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("年龄")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("检查项目")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "margin-top": "100px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/image/defaultpic.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "margin-top": "20px",
      "text-align": "center"
    }
  }, [_vm._v("暂无数据")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "display": "block",
      "margin-top": "120px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/image/defaultpic.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-1e17302b","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/teachRoom/teachRoom.vue
// module id = 537
// module chunks = 1 2 3 4 5 6 7 8